import React from 'react';
import Menu from '../../modules/Menu/component';
import NewSection from '../../modules/NewSection/container';

const getTitle = paramSection => paramSection.replace(/_/g, ' ');

const SectionPage = ({ params }) => (
  <div className="main-page">
    <Menu title={getTitle(params.section)} />
    <NewSection sectionTitle={getTitle(params.section)} />
  </div>
);

export default SectionPage;



// WEBPACK FOOTER //
// ./src/pages/section-page/index.js